import * as XLSX from 'xlsx';
import { Injectable } from '@angular/core';
import { BaseService } from "../../services/_base.service";
import { HttpClient } from "@angular/common/http";
import { UserService } from "../../services/user.service";
import { ICRUDService } from '../../shared/crud-manager/crud.interface';
import { catchError, map, throwError } from 'rxjs';

export interface IUserStatistics {
  total_count: number;
  actives_count: number;
  inactives_count: number;
}

@Injectable({
  providedIn: "root"
})
export class UsersService extends BaseService implements ICRUDService {
  params = [
    'name', 
    'rut', 
    'mail', 
    'password', 
    'password_confirmation', 
    'role_id', 
    'active', 
    'online', 
    'workpoint_code', 
    'phone', 
    'location_ids', 
    'block_hours'
  ];
  model = 'User';
  
  constructor(public http: HttpClient, userService: UserService) {
    super();
  }
  
  index(value = null, page = 1) {
    return this.http.get(
      this.adminURL + '/users', 
      this.getParams({ search: value, page: page })
    );
  }
  
  create(value) {
    return this.http.post(
      this.adminURL + '/users/', 
      {
        user: this.permitParams(value, ...this.params)
      }, 
      this.getParams()
    );
  }
  
  update(id, value) {
    return this.http.put(
      this.adminURL + '/users/' + id, 
      {
        user: this.permitParams(value, ...this.params)
      }, 
      this.getParams()
    );
  }
  
  destroy(id) {
    return this.http.delete(
      this.adminURL + '/users/' + id, 
      this.getParams()
    );
  }
  
  restore(id) {
    return this.http.delete(
      this.adminURL + '/users/' + id + '/restore', 
      this.getParams()
    );
  }

  getStatistics() {
    return this.http.get<IUserStatistics>(
      this.adminURL + '/users/statistics', 
      this.getParams()
    ).pipe(
      catchError((error) => {
        console.error('Error fetching user statistics:', error);
        return throwError(() => error);
      }),
    );
  }

  export(columns: string[]) {
    return this.http.get<unknown[]>(
      this.adminURL + '/users/export',
      this.getParams({ 'columns[]': columns })
    ).pipe(
      catchError((error) => {
        console.error('Error exporting users:', error);
        return throwError(() => error);
      }),
      map(response => {
        const data: unknown[] = response.body;
        const excelFileName = 'Usuarios';
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        const today = new Date();
        const date = `${today.getFullYear()}${today.getMonth() + 1}${today.getDate()}`;
        const time = `${today.getHours()}${today.getMinutes()}${today.getSeconds()}`;
        const name = excelFileName + date + time;
        XLSX.writeFile(workbook, `${name}.xlsx`);
        return true;
      })

    )
  }
}
